import axios from 'axios';
import { URL_API } from '../../../../../setup/config/env';

// Profile
export default function projectsByGroups(groupsSelected, refreshToken) {
  return axios.get(`${URL_API}/gitlab/projectsByGroups`, {
    params: { groups: JSON.stringify(groupsSelected), token: refreshToken },
  });
}
